
import Vue from 'vue'
import { minLength, required, email } from 'vuelidate/lib/validators'
import { userLogin } from '@/connectors/user'
import {mapActions} from "vuex";

export default Vue.extend({
  name: 'Login',
  data () {
    return {
      errorMessage: 'Введены неверные данные',
      login: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    ...mapActions('profile', [
      'getInfo'
    ]),
    authorization () {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }
      userLogin(this.login)
        .then(async () => {
          await this.getInfo()
          this.$router.push('/app/account')
        }).catch((e) => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(this.errorMessage)
        })
    }
  },
  validations: {
    login: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      }
    }
  }
})
